// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const es: ChromeTranslations = {
  'nav.nextPage': 'página siguiente →',
  'nav.previousPage': '← página anterior',
  'nav.continueToLevel': 'continuar al nivel →',
  'nav.backToMenu': 'volver al menú →',
  'howto.page': 'página {n} de {total}',
  'options.title': 'Opciones',
  'ui.language': 'Idioma',
};
